// @see mylw-hopons.nexcess-internal.workers.dev
import uatTemplate from './uat';
import type { AppConfigI } from './example';

const hopons: AppConfigI = {
	...uatTemplate,
	openId: {
		...uatTemplate.openId,
		client_id: 'mylw-hopons-cp',
	},
	headsUpDisplay: true,
	// Methodic dev channel key, shared with dev/UAT until Methodic provisions
	// production servers and issues a prod key (separate bot).
	methodic: {
		__: 'NOT A SECRET — public `STREAMING_WEB-` channel embed identifier',
		moduleUrl: 'https://widget-nexcess.methodic.ai/client.js',
		apiKey: 'STREAMING_WEB-admin_3230-fbc02afd-c9d7-40d9-8bbc-be917197a36c',
		agentId: '',
		embedType: 'popup',
	},
};

export default hopons;
